import Login from "./Pages/Login";
import Navbar from "./Components/Navbar";
import Main from "./Main";

import { useContext} from "react";
import axios from "axios";
import AuthContext from "./Context/AuthContext";
axios.defaults.baseURL = "https://gestapo.sisc.ro/api/";

function App() {

  const { user } = useContext(AuthContext);


  if (user == undefined || !user.isAdmin)
    return (
      <div>
        <Login />
      </div>
    );
  else {
    return (
      <>
        <Navbar />
        <Main />
      </>
    );
  }
}

export default App;
